import React from "react";
import styles from "./Slide2.module.scss";
import { useIntl } from "react-intl";
import { messages } from "../../Introduction.messages";

export const Slide2: React.FC = () => {
  const { formatMessage } = useIntl();
  return (
    <div className={styles.slide2}>
      <h2 className={styles.title}>{formatMessage(messages.slide2Title)}</h2>
      <div className={styles.content}>
        <div className={styles.contentItem}>
          <h3>{formatMessage(messages.slide2Title1)}</h3>
          <p>{formatMessage(messages.slide2Description1)}</p>
        </div>
        <div className={styles.contentItem}>
          <h3>{formatMessage(messages.slide2Title2)}</h3>
          <p>{formatMessage(messages.slide2Description2)}</p>
        </div>
        <div className={styles.contentItem}>
          <h3>{formatMessage(messages.slide2Title3)}</h3>
          <p>{formatMessage(messages.slide2Description3)}</p>
        </div>
      </div>
    </div>
  );
};
